import {RequestState} from "../../models/common/RequestState";
import {Employee} from "../../models/users/Employee";
import {
    CHECK_EMAIL_UNIQUENESS,
    CHECK_EMAIL_UNIQUENESS_ERROR,
    CHECK_EMAIL_UNIQUENESS_SUCCESS,
    CREATE_EMPLOYEE,
    CREATE_EMPLOYEE_ERROR,
    CREATE_EMPLOYEE_SUCCESS,
    DELETE_EMPLOYEE,
    DELETE_EMPLOYEE_ERROR,
    DELETE_EMPLOYEE_SUCCESS,
    EmployeeActionTypes,
    FETCH_EMPLOYEE,
    FETCH_EMPLOYEE_ERROR,
    FETCH_EMPLOYEE_SUCCESS,
    FETCH_EMPLOYEES,
    FETCH_EMPLOYEES_ERROR,
    FETCH_EMPLOYEES_SUCCESS,
    UPDATE_EMPLOYEE_SUCCESS,
    UPDATE_EMPLOYEE_ERROR,
    UPDATE_EMPLOYEE,
    RESTORE_EMPLOYEE,
    RESTORE_EMPLOYEE_ERROR,
    RESTORE_EMPLOYEE_SUCCESS
} from "../../actions/employees/EmployeeActions";

export interface EmployeesState {
    totalEntries: number
    form: { isLoginMailUnique: boolean }
    detailedEmployees: { [ key: number ]: Employee }
    employees: null | Employee[],
    request: RequestState
}

const initialState: EmployeesState = {
    form: {
        isLoginMailUnique: true
    },
    totalEntries: 0,
    detailedEmployees: {},
    employees: null,
    request: { error: null, isFetching: false, lastRequestSuccess: 0 }
};


export const EmployeesReducer = ( state = initialState, action: EmployeeActionTypes ): EmployeesState => {
    switch( action.type ) {
        case FETCH_EMPLOYEES:
            return {
                ...state,
                request: {
                    isFetching: true,
                    error: null,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_EMPLOYEES_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                employees: action.payload.entries,
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case FETCH_EMPLOYEES_ERROR:
            return {
                ...state,
                request: {
                    lastRequestSuccess: 0,
                    error: action.error,
                    isFetching: false
                }
            };
        case FETCH_EMPLOYEE:
            return {
                ...state,
                request: {
                    isFetching: true,
                    error: null,
                    lastRequestSuccess: 0
                }
            };
        case FETCH_EMPLOYEE_ERROR:
            return {
                ...state,
                request: {
                    lastRequestSuccess: 0,
                    error: action.error,
                    isFetching: false
                }
            };
        case FETCH_EMPLOYEE_SUCCESS:
            return {
                ...state,
                detailedEmployees: {
                    ...state.detailedEmployees,
                    [ action.payload.userId.rawValue ]: {
                        ...action.payload,
                        birthday: ( action.payload.birthday !== null ) ? new Date( action.payload.birthday ) : null
                    }
                },
                request: {
                    isFetching: false,
                    error: null,
                    lastRequestSuccess: Date.now()
                }
            };
        case CREATE_EMPLOYEE:
            return {
                ...state,
                request: {
                    isFetching: true,
                    error: null,
                    lastRequestSuccess: 0
                }
            };
        case CREATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                employees: ( state.employees === null ) ? [ action.employee ] : [ ...state.employees, action.employee ],
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case CREATE_EMPLOYEE_ERROR:
            return {
                ...state,
                request: {
                    isFetching: false,
                    lastRequestSuccess: 0,
                    error: action.error
                }
            };
        case UPDATE_EMPLOYEE:
            return {
                ...state,
                request: {
                    isFetching: true,
                    error: null,
                    lastRequestSuccess: 0
                }
            };
        case UPDATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                employees: ( state.employees === null ) ? [ action.employee ] : [ ...state.employees, action.employee ],
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case UPDATE_EMPLOYEE_ERROR:
            return {
                ...state,
                request: {
                    isFetching: false,
                    lastRequestSuccess: 0,
                    error: action.error
                }
            };
        case CHECK_EMAIL_UNIQUENESS:
            return {
                ...state,
                request: {
                    isFetching: true,
                    lastRequestSuccess: 0,
                    error: null
                }
            };
        case CHECK_EMAIL_UNIQUENESS_SUCCESS:
            return {
                ...state,
                form: {
                    isLoginMailUnique: ( action.mailCount === 0 )
                },
                request: {
                    ...state.request,
                    isFetching: false,
                    lastRequestSuccess: Date.now()
                }
            };
        case CHECK_EMAIL_UNIQUENESS_ERROR:
            return {
                ...state,
                request: {
                    isFetching: false,
                    lastRequestSuccess: 0,
                    error: action.error
                }
            };
        case DELETE_EMPLOYEE:
            return {
                ...state,
                request: {
                    isFetching: true,
                    error: null,
                    lastRequestSuccess: 0
                }
            };
        case DELETE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                detailedEmployees: {
                    ...state.detailedEmployees,
                    [ action.id ]: {
                        ...state.detailedEmployees[ action.id ],
                        isDeleted: true
                    }
                },
                request: {
                    isFetching: false,
                    lastRequestSuccess: Date.now(),
                    error: null
                }
            };
        case DELETE_EMPLOYEE_ERROR:
            return {
                ...state,
                request: {
                    isFetching: false,
                    lastRequestSuccess: 0,
                    error: action.error
                }
            };
        case RESTORE_EMPLOYEE:
            return {
                ...state,
                request: {
                    isFetching: true,
                    error: null,
                    lastRequestSuccess: 0
                }
            };
        case RESTORE_EMPLOYEE_SUCCESS:

            return {
                ...state,
                detailedEmployees: {
                    ...state.detailedEmployees,
                    [ action.id ]: {
                        ...state.detailedEmployees[ action.id ],
                        isDeleted: false
                    }
                },
                request: {
                    isFetching: false,
                    lastRequestSuccess: Date.now(),
                    error: null
                }
            };
        case RESTORE_EMPLOYEE_ERROR:
            return {
                ...state,
                request: {
                    isFetching: false,
                    lastRequestSuccess: 0,
                    error: action.error
                }
            };
        default:
            return state;
    }
};